module.exports = __webpack_public_path__ + "img/no-receipt.8213754f.png";